import { Stack } from '@mui/material';

import Meta from '@/components/Meta';
import GlobalHeader from '@/sections/GlobalHeader';

import Chains from './Chains';
import ModelAPIs from './ModelAPIs';
import Models from './Models';
import Overview from './Overview';
import Sidebar from './Sidebar';
import Training from './Training';
import { useWorkspaceSection } from './hooks';
import { WorkspaceSections } from './types';
import { mapSectionToTitle } from './utils';

const workspaceSectionComponents = {
  [WorkspaceSections.Models]: Models,
  [WorkspaceSections.ModelAPIs]: ModelAPIs,
  [WorkspaceSections.Chains]: Chains,
  [WorkspaceSections.Training]: Training,
  [WorkspaceSections.Overview]: Overview,
};

function Workspace() {
  const section = useWorkspaceSection();
  const SectionComponent = workspaceSectionComponents[section];

  return (
    <Meta title={`${mapSectionToTitle[section]} | Baseten`}>
      <GlobalHeader />
      <Stack direction="row" overflow="hidden" height="100%" flex={1}>
        <Sidebar selectedSection={section} />
        <Stack overflow="auto" flex={1} height="100%">
          <SectionComponent />
        </Stack>
      </Stack>
    </Meta>
  );
}

export default Workspace;
